module.exports = __webpack_public_path__ + "img/pic-2.39a1cb54.png";